import { environment } from '../environments/environment';

export interface IConfig  {
    apiDomain: string;
    baseUrl: string,
    apiPath : string,
    apiToken: string,
    defaultScreenWidth: number,
    defaultScreenHeight: number,
    aspectRatio: number,
    isScaled: boolean,
    LOG_LEVEL: number,
    magentoProductFiles,
    configurationFiles
}

export const CONFIG: IConfig = {
    apiDomain: "",
    baseUrl: environment.basePath,
    apiPath : environment.basePath,
    apiToken: "",
    defaultScreenWidth: 1920,
    defaultScreenHeight: 1200,
    aspectRatio: 1920/1200,
    isScaled: false,
    LOG_LEVEL: environment.LOG_LEVEL,

    magentoProductFiles: {
        '1': 'products_1.json',
        '2': 'products_2.json',
        '3': 'products_3.json'
    },
    configurationFiles: {
        '1': 'configuration_1.json',
        '2': 'configuration_2.json',
        '3': 'configuration_3.json'
    }
};


// WEBPACK FOOTER //
// ./src/app/config.ts